import React, { useState } from 'react';
import * as Yup from 'yup';
import { TextField, MenuItem } from '@mui/material';
import MasterManager from '../../components/expense/MasterManager';
import useExpenseLookups, { withCurrent } from '../../components/expense/useExpenseLookups';

const schema = Yup.object().shape({
  categoryId: Yup.string().required('Category is required'),
  name: Yup.string().trim().required('Name is required').max(150),
});

// Owner: Accounts. A head always belongs to one category.
const ExpenseHeadMaster = ({ canEdit }) => {
  const { categories } = useExpenseLookups(['categories']);
  const [categoryId, setCategoryId] = useState('');

  return (
    <MasterManager
      resource="heads"
      title="Expense Head"
      canEdit={canEdit}
      extraParams={{ categoryId }}
      toolbar={(
        <TextField
          select size="small" label="Category" value={categoryId}
          onChange={(e) => setCategoryId(e.target.value)} sx={{ minWidth: 220 }}
        >
          <MenuItem value=""><em>All categories</em></MenuItem>
          {categories.map((c) => <MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>)}
        </TextField>
      )}
      columns={[
        { key: 'name', label: 'Head' },
        { key: 'category', label: 'Category', render: (r) => r.categoryId?.name || '' },
      ]}
      fields={(editing) => [
        {
          name: 'categoryId', label: 'Category', type: 'select', required: true,
          options: withCurrent(categories, editing?.categoryId?._id, editing?.categoryId?.name),
        },
        { name: 'name', label: 'Head Name', required: true },
      ]}
      validationSchema={schema}
      emptyValues={{ categoryId: categoryId || '', name: '' }}
      toForm={(r) => ({ categoryId: r.categoryId?._id || '', name: r.name || '' })}
      toPayload={(v) => ({ categoryId: v.categoryId, name: v.name })}
    />
  );
};

export default ExpenseHeadMaster;
